import Component from 'flarum/common/Component';

/**
 * A sortable table: click a column to sort (again to reverse); scrolls sideways on phones; CSV download.
 * attrs: cols [{ key, label, sort: (row) => value, show: (row) => text|vnode, csv?: (row) => text }], rows, filename, sort (initial key),
 *        limit (rows shown before "Show all"), search (placeholder: adds a search box; searching shows every match)
 */
export default class SortTable extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.key = this.attrs.sort || this.attrs.cols[0].key;
    this.dir = 1;
    this.query = '';
    this.all = false;
  }
  view() {
    const {
      cols,
      filename,
      search
    } = this.attrs;
    const limit = this.attrs.limit === 0 ? 0 : this.attrs.limit || 10; // every table: 10 rows, then "Show all"
    const q = this.query.trim().toLowerCase();
    // Searching looks through every column's text
    const rows = q ? this.attrs.rows.filter(r => cols.map(c => c.csv ? c.csv(r) : c.show(r)).filter(v => typeof v === 'string' || typeof v === 'number').join(' ').toLowerCase().includes(q)) : this.attrs.rows;
    const col = cols.find(c => c.key === this.key) || cols[0];
    const sorted = rows.slice().sort((a, b) => {
      const x = col.sort(a);
      const y = col.sort(b);
      const missing = v => v === null || v === undefined || v === '';
      if (missing(x) !== missing(y)) return missing(x) ? 1 : -1; // empty values always last
      return (typeof x === 'number' && typeof y === 'number' ? x - y : String(x).localeCompare(String(y))) * this.dir;
    });
    const sortBy = c => {
      this.dir = this.key === c.key ? -this.dir : c.desc ? -1 : 1;
      this.key = c.key;
    };

    // Before searching: the first `limit` rows, then "Show all"
    const capped = limit && !q && !this.all && sorted.length > limit;
    const visible = capped ? sorted.slice(0, limit) : sorted;
    return m("div", {
      className: "DHTable"
    }, search ? m("div", {
      className: "DHTable-search"
    }, m("i", {
      className: "fas fa-search",
      "aria-hidden": "true"
    }), m("input", {
      type: "search",
      placeholder: search,
      value: this.query,
      oninput: e => this.query = e.target.value,
      "aria-label": search
    }), this.query ? m("button", {
      className: "DHTable-clear",
      "aria-label": "Clear search",
      onclick: () => this.query = ''
    }, m("i", {
      className: "fas fa-times"
    })) : null) : null, m("div", {
      className: "DHTable-wrap"
    }, m("table", null, m("thead", null, m("tr", null, cols.map(c => m("th", {
      className: this.key === c.key ? 'is-sorted' : '',
      onclick: () => sortBy(c)
    }, c.label, " ", this.key === c.key ? m("i", {
      className: 'fas fa-caret-' + (this.dir > 0 ? 'up' : 'down')
    }) : null)))), m("tbody", null, visible.map(r => m("tr", null, cols.map(c => {
      const v = c.show(r);
      return m("td", {
        className: c.strong ? 'is-strong' : ''
      }, v === null || v === undefined || v === '' ? m("span", {
        className: "DHMuted"
      }, "\u2014") : v);
    })))))), q && !sorted.length ? m("p", {
      className: "DHMuted DHTable-note"
    }, "No matches for \"", this.query.trim(), "\".") : null, capped ? m("div", {
      className: "DHTable-more"
    }, m("button", {
      className: "Button",
      onclick: () => this.all = true
    }, "Show all ", sorted.length), m("span", {
      className: "DHMuted"
    }, "or search above")) : null, limit && this.all && !q && sorted.length > limit ? m("div", {
      className: "DHTable-more"
    }, m("button", {
      className: "Button",
      onclick: () => this.all = false
    }, "Show top ", limit)) : null, filename ? m("button", {
      className: "DHLink DHTable-csv",
      onclick: () => this.download(sorted)
    }, m("i", {
      className: "fas fa-download"
    }), " Download CSV") : null);
  }
  download(sorted) {
    const {
      cols,
      filename
    } = this.attrs;
    const text = (r, c) => {
      const v = c.csv ? c.csv(r) : c.show(r);
      return v === null || v === undefined || typeof v === 'object' ? '' : String(v);
    };
    const esc = v => /[",\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v;
    const csv = [cols.map(c => esc(c.label)).join(','), ...sorted.map(r => cols.map(c => esc(text(r, c))).join(','))].join('\n');
    const url = URL.createObjectURL(new Blob(['\ufeff' + csv], {
      type: 'text/csv;charset=utf-8'
    }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}